"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const classnames_1 = __importDefault(require("classnames"));
const react_1 = __importDefault(require("react"));
const LoadingSpinner_1 = __importDefault(require("../components/LoadingSpinner"));
const ButtonSize_1 = __importDefault(require("../enums/ButtonSize"));
const ButtonVariant_1 = __importDefault(require("../enums/ButtonVariant"));
const Icon_1 = __importDefault(require("./Icon"));
const Button = ({ variant, size = ButtonSize_1.default.default, text, className, icon, iconLeft, iconRight, image, disabled, onClick, loading, ...buttonProps }) => {
    return (react_1.default.createElement("button", { className: (0, classnames_1.default)(`btn-${variant}`, 'btn', 'd-flex', 'align-items-center', {
            'btn-sm': size === ButtonSize_1.default.small,
            'btn-block': size === ButtonSize_1.default.block,
            '--has-icon': (icon || loading) && text,
            '--icon-only': icon && !text && !image,
            '--image-only': image && !text && !icon,
            '--text': variant === ButtonVariant_1.default.text,
        }, className), disabled: disabled, onClick: onClick, ...buttonProps },
        iconLeft ? react_1.default.createElement(Icon_1.default, { name: iconLeft, className: "btn__icon-left" }) : null,
        react_1.default.createElement("span", null, text),
        icon && !loading ? react_1.default.createElement(Icon_1.default, { name: icon, className: 'icon' }) : null,
        loading ? react_1.default.createElement(LoadingSpinner_1.default, { className: "btn__loader" }) : null,
        image ? react_1.default.createElement("img", { className: "btn__image", src: image, alt: "" }) : null,
        iconRight && !loading ? react_1.default.createElement(Icon_1.default, { name: iconRight, className: "btn__icon-right" }) : null));
};
exports.default = Button;
